enum ListingSortColumn {
  SoldDate = 'SoldDate',
  CreateDate = 'CreateDate',
  SalePrice = 'SalePrice',
  SoldPrice = 'SoldPrice',
  Suburb = 'Suburb',
  LastUpdatedDate = 'LastUpdatedDate'
}

enum SortType {
  Asc = 'Asc',
  Desc = 'Desc'
}

interface OrderByStatement {
  Column: ListingSortColumn;
  Type: SortType;
}

export { ListingSortColumn, SortType, OrderByStatement }